<template>
    <tr class="item-summary">
        <td>
            <div class="document">
                <div class="document-name">
                    <span>{{ documentName }}</span>
                </div>
            </div>
        </td>
        
        <td align="right">
            <button class="btn btn-complete btn-sm" @click="toggleDetails">
                <i v-if="showDetails" class="fa fa-chevron-up"></i>
                <i v-else class="fa fa-chevron-down"></i>
                Gérer
            </button>
        </td>
    </tr>
</template>

<script type="text/babel">
export default {
    name:"DocumentItemSummary",
    
    props: {
        documentName: {
            type: String,
            required: true
        }
    },
    
    data () {
        return {
            showDetails: false
        }
    },

    methods: {
        toggleDetails() {
            this.showDetails = !this.showDetails
            this.$emit('toggle-details')
        }
    }
}
</script>

<style lang="scss" scoped>
    tr.item-summary {
        .document {
            .document-name {
                font-weight: 600;

                .btn {
                    font-size: 12px;
                    padding: 4px 12px;
                }

                > span {
                    margin-right: 5px;
                }
            }
        }

        td {
            vertical-align: middle;
            padding: 12px;
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InternalDocuments/ItemSummary.vue